import { render, staticRenderFns } from "./myInfo.vue?vue&type=template&id=65dd79d6&scoped=true"
import script from "./myInfo.vue?vue&type=script&lang=js"
export * from "./myInfo.vue?vue&type=script&lang=js"
import style0 from "./myInfo.vue?vue&type=style&index=0&id=65dd79d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd79d6",
  null
  
)

export default component.exports